import { last, first } from "lodash";
import { useParameter, useDictionaryItem, yearToCropYearShort } from "../../../shared";
import { dictionaryService } from "../../../dataFlow";

export function useSlideSubtitle() {
  const [parameterValues] = useParameter<number[]>("@calendar");
  const [, calendarName] = useDictionaryItem(dictionaryService, "slides-calendar", last(parameterValues));
  const year = calendarName ? Number(calendarName) : new Date().getFullYear() - 1;
  const subtitle = `${yearToCropYearShort(year)} vs. ${yearToCropYearShort(year - 1)}`;

  return subtitle;
}
